import { render, staticRenderFns } from "./viewAvgSlider.vue?vue&type=template&id=1c300986&scoped=true&"
import script from "./viewAvgSlider.vue?vue&type=script&lang=js&"
export * from "./viewAvgSlider.vue?vue&type=script&lang=js&"
import style0 from "./viewAvgSlider.vue?vue&type=style&index=0&id=1c300986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c300986",
  null
  
)

export default component.exports